import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class OrderCar extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/order/car`)
  }

  initiate(carId, model, showProgress) {
    return this._request({
      action: `${carId}/initiate`,
      body: model,
      method: 'PATCH',
      showProgress
    })
  }

  revertInitiate(carId, showProgress) {
    return this._request({
      action: `${carId}/revert/initiate`,
      method: 'PATCH',
      showProgress
    })
  }

  loading(carId, model, showProgress) {
    return this._request({
      action: `${carId}/loading`,
      body: model,
      method: 'PATCH',
      showProgress
    })
  }

  revertLoading(carId, showProgress) {
    return this._request({
      action: `${carId}/revert/loading`,
      method: 'PATCH',
      showProgress
    })
  }

  reachOrigin(carId, model, showProgress) {
    return this._request({
      action: `${carId}/reachOrigin`,
      body: model,
      method: 'PATCH',
      showProgress
    })
  }

  revertReachOrigin(carId, showProgress) {
    return this._request({
      action: `${carId}/revert/reachOrigin`,
      method: 'PATCH',
      showProgress
    })
  }

  reachDestination(carId, model, showProgress, destinationId) {
    return this._request({
      action: `${carId}/reachDestination`,
      params: { destinationId },
      body: model,
      method: 'PATCH',
      showProgress
    })
  }

  revertReachDestination(carId, showProgress) {
    return this._request({
      action: `${carId}/revert/reachDestination`,
      method: 'PATCH',
      showProgress
    })
  }

  discharge(carId, model, showProgress) {
    return this._request({
      action: `${carId}/discharge`,
      body: model,
      method: 'PATCH',
      showProgress
    })
  }

  revertDischarge(carId, showProgress) {
    return this._request({
      action: `${carId}/revert/discharge`,
      method: 'PATCH',
      showProgress
    })
  }

  deliveryCode(orderId, showProgress) {
    return this._request({
      action: `${orderId}/deliveryCode`,
      method: 'PATCH',
      showProgress
    })
  }

  updateDriver(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/updateDriver`,
      method: 'PUT',
      body: model,
      showProgress
    })
  }
  getArchiveDriver(orderId, showProgress) {
    return this._request({
      action: `${orderId}/archiveDrivers`,
      method: 'GET',
      showProgress
    })
  }
}
